var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundcloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.12 17.7399V33.9999H40.64C44.34 33.7399 46 31.4599 46 28.6599C46 25.6999 43.76 23.3199 40.76 23.3199C40 23.3199 39.36 23.4799 38.7 23.7599C38.22 19.0799 34.24 15.4199 29.34 15.4199C27 15.4199 24.78 16.2999 23.12 17.7399ZM21.36 19.7799C20.76 19.4199 20.12 19.1399 19.42 18.9999V33.9999H22.2V18.6799C21.9 18.9999 21.62 19.3999 21.36 19.7799ZM16.66 18.6999V33.9999H18.5V18.7599C18.12 18.6999 17.74 18.6799 17.34 18.6799C17.1 18.6799 16.88 18.6799 16.66 18.6999ZM13 19.9999V33.9999H14.82V19.0799C14.16 19.2999 13.54 19.6199 13 19.9999ZM9.66 24.9999C9.54 24.9999 9.42 24.8799 9.28 24.8199V33.9999H11.12V21.7199C10.38 22.6799 9.88 23.8199 9.66 24.9999ZM5.58 24.4399V33.8199C6 33.9399 6.48 33.9999 7 33.9999H7.44V24.2799C7.28 24.2599 7.12 24.2399 7 24.2399C6.48 24.2399 6 24.3199 5.58 24.4399ZM2 29.1199C2 30.6199 2.68 31.9399 3.74 32.8399V25.4199C2.68 26.2999 2 27.6399 2 29.1199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloud);
export default __webpack_public_path__ + "static/media/soundcloud.4f39565001b5f46bee0a2f8d39d81e55.svg";
export { ForwardRef as ReactComponent };